import i18n from '@/i18n';
import axios from 'axios';
import store from '@/store';
import moment from 'moment';
import base from '@/__vue2stone/service/wasaapi/v1/__base';
import S_auditRecord from '@/service/api/v1/audit_record';
import S_checklistRecord from '@/service/api/v1/checklist_record';
import S_factorySystemClass from '@/service/api/v1/factorySystemClass';
import H_time from '@/helpers/time';
import H_checklist from '@/helpers/checklist';
import H_checklistRecord from '@/helpers/checklistRecord';

export default{
  async $_getAuditRecord(query){
    const res = await base.show({
      modelName: query.modelName,
      modelId: query.recordId,
      params: {
        factory: store.state.app.factoryId,
      },
    });
    return res;
  },
  async $_setAuditRecordFieldData(apiData, indexList){
    const chapterList = await S_auditRecord.getChapterList(apiData);
    for (let key in indexList) {
      for (const field of indexList[key]) {
        if (apiData[field.value] !== undefined && !field.isRead) {
          if (apiData[field.value] !== null
          && apiData[field.value].name !== undefined) {
            field.data = apiData[field.value].name;
          } else {
            field.data = apiData[field.value]
            ? apiData[field.value]
            : `${i18n.t('無')}`;
          }
        }
        if (field.value === 'multiSystemSubclasses') {
          field.data = await this.$_setMultiSystemSubclasses(apiData);
        }
        if (field.type === 'time'){
          field.data = field.data === `${i18n.t('無')}`
            ? field.data
            : H_time.getDateDashFormat(field.data, 'YYYY-MM-DD HH:mm:ss');
        }
        if (field.value === 'current_time') {
          field.data = moment().format('YYYY-MM-DD HH:mm:ss');
        }
        if (field.type === 'percentage' && field.data !== `${i18n.t('無')}`){
          field.data = `${field.data}%`;
        }
        if (field.value === 'current_factory') {
          field.data = `${i18n.t(`${store.state.app.factory.name}`)}`;
        }
        if (field.value === 'risk_level') {
          field.data = this.$_getAuditRiskLevel(apiData);
        }
        if (field.value === 'chapterList') {
          field.data = chapterList;
        }
      }
    }
    return indexList
  },
  async $_getChecklistRecord(query){
    const { recordId } = query;
    const recordRes = await S_checklistRecord.show(recordId);
    const answerRes = await S_checklistRecord.answerIndex(recordId);
    recordRes.checklist_record_answers = answerRes;
    return recordRes;
  },
  async $_setChecklistRecordFieldData(apiData, printField){
    for (let key in printField) {
      const field = printField[key];
      for (const item of field) {
        if (item.value === 'factory') {
          item.data = store.state.app.factory.name;
        }
        if (item.value === 'multiSystemSubclasses') {
          item.data = await this.$_setMultiSystemSubclasses(apiData);
        }
        if (item.value === 'printDate') {
          item.data = moment().format('YYYY-MM-DD HH:mm:ss');
        }
        if (item.value === 'result') {
          item.data = this.$_setResult(apiData);
        }
        if (item.value === 'passRate') {
          item.data = apiData.pass_rate
            ? `${apiData.pass_rate}%`
            : i18n.t('無');
        }
        if (item.value === 'riskLevelScore23') {
          item.data = this.$_setRiskLevel(apiData, 23);
        }
        if (item.value === 'riskLevelScore22') {
          item.data = this.$_setRiskLevel(apiData, 22);
        }
        if (item.value === 'riskLevelScore21') {
          item.data = this.$_setRiskLevel(apiData, 21);
        }
        if (item.value === 'riskLevelScore25') {
          item.data = this.$_setRiskLevel(apiData, 25);
        }
        if (item.type === 'question') {
          item.data = H_checklistRecord.setRecordQuesList(apiData.checklist_record_answers);
        }
        if (item.type === 'generalRecord') {
          item.data = this.$_setGeneralRecord(apiData);
        }
        if (item.value === 'duration') {
          item.data = H_checklist.setAssignmentDuration(apiData);
        }
      }
    }
    return printField;
  },
  async $_setMultiSystemSubclasses(apiData) {
    const systemText = this.$_setSystemClasses(apiData);
    const factoryText = await this.$_setFactorySystemClasses(apiData);
    return [systemText, factoryText].filter(Boolean).join('\n');
  },
  async $_setFactorySystemClasses(apiData) {
    const subclassIds = (apiData.factory_system_subclasses || [])
      .map(({ id }) => id)
      .filter(id => id != null);

    if (!subclassIds.length) {
      return '';
    }

    let res;
    try {
      res = await S_factorySystemClass.indexFactory({}, false);
    } catch (error) {
      window.alert(i18n.t('取得自訂領域失敗，請稍後再試'));
      throw error;
    }

    const subclassIdSet = new Set(subclassIds);

    return (res || []).reduce((result, { name, factory_system_classes = [] }) => {
      const matchedNames = [];

      for (const { id, name: subclassName } of factory_system_classes) {
        if (subclassIdSet.has(id)) {
          matchedNames.push(subclassName);
        }
      }

      if (matchedNames.length) {
        result.push(`${name} | ${matchedNames.join(' 、')}`);
      }

      return result;
    }, []).join('\n');
  },
  $_setSystemClasses(apiData) {
    const subclassIds = new Set(
      (apiData.system_subclasses || []).map(({ id }) => id)
    );

    return store.state.model.systemClasses.reduce((result, { name, system_subclasses = [] }) => {
      const matchedNames = [];

      for (const { id, name: subclassName } of system_subclasses) {
        if (subclassIds.has(id)) {
          matchedNames.push(subclassName);
        }
      }

      if (matchedNames.length) {
        result.push(`${name} | ${matchedNames.join(' 、')}`);
      }

      return result;
    }, []).join('\n');
  },
  $_setResult(apiData) {
    const majorRiskNum = this.$_setRiskLevel(apiData, 23);
    const minorRiskNum = this.$_setRiskLevel(apiData, 22);
    const ofiRiskNum = this.$_setRiskLevel(apiData, 21);
    return majorRiskNum >= 1
      ? i18n.t("高風險")
      : minorRiskNum >= 1
      ? i18n.t("中風險")
      : ofiRiskNum >= 1
      ? i18n.t("低風險")
      : parseInt(apiData.status) === 1
      ? i18n.t("不需點檢")
      : i18n.t("無異常");
  },
  $_getAuditRiskLevel(data){
    const score = data.risk_level;
    let riskLevel = '';
    switch (score) {
      case 25:
        riskLevel = i18n.t('合規');
        break;
      case 23:
        riskLevel = i18n.t('高風險');
        break;
      case 22:
        riskLevel = i18n.t('中風險');
        break;
      case 21:
        riskLevel = i18n.t('低風險');
        break;
      default:
        riskLevel = i18n.t('尚無結果');
    }
    return riskLevel;
  },
  $_setRiskLevel(apiData, score){
    if (apiData.level_payload) {
      const item = apiData.level_payload.find((p) => p.level === score);
      return item ? item.number : 0;
    }
    const answerList = apiData.checklist_record_answers || [];
    if (answerList.length === 0) return i18n.t('無');
    return answerList.filter((a) => a.risk_level === score).length;
  },
  $_setGeneralRecord(apiData) {
    const sampleList = H_checklistRecord.setSampleAndReviewList(apiData, 'sample').map(record => {
      return {
        ...record,
        score: record.score.color === 'green'
          ? i18n.t('通過')
          : i18n.t('不通過')
      }
    });
    const reviewList = H_checklistRecord.setSampleAndReviewList(apiData, 'review').map(record => {
      return {
        ...record,
        score: record.score.color === 'green'
          ? i18n.t('通過')
          : i18n.t('不通過')
      }
    });
    return {sampleList, reviewList};
  },
  async $_getActData(query){
    let allSelectSystem = [];
    const allSystemClass = [...store.state.model.systemClasses];
    allSystemClass.forEach((system) => {
      let selectSubclass = system.system_subclasses.filter((subclass) =>
        query.system_subclasses.split(",").includes(`${subclass.id}`)
      );
      if (selectSubclass.length === 0) return;
      let selectSystem = JSON.parse(JSON.stringify(system));
      selectSystem.system_subclasses = selectSubclass;
      allSelectSystem.push(selectSystem);
    });
    let IndexSystemList = allSelectSystem.map((system) => {
      return {
        id: system.id,
        title: system.name,
        systemSubclassList: system.system_subclasses.map((subclass) => {
          return {
            id: subclass.id,
            title: subclass.name,
            iconImg: subclass.icon,
            isStart: true,
            typeList: [],
          };
        }),
      };
    });
    const task = []
    let res = null
    IndexSystemList.forEach((listItem)=>{
      listItem.systemSubclassList.forEach((systemItem)=>{
        const params = {
          order_by: "act_type",
          order_way: "asc",
          system_classes: listItem.id,
          system_subclasses: systemItem.id,
          time_field: "announce_at",
          start_time: query.start_time,
          end_time: query.end_time,
          act_type: query.act_type,
          factory: store.state.app.factoryId,
          get_all: 1,
        };
        const _url = `/factory/${store.state.app.factoryId}/${query.url}`
        task.push(axios.get(_url,{params}))
      })
    })
    try {
      res = await Promise.all(task)
    } catch (error) {
      alert(error)
    }
    IndexSystemList.forEach((listItem)=>{
      listItem.systemSubclassList.forEach(async (systemItem)=>{
        const data = res.shift().data.data
        systemItem.typeList = this.$_getActPrintTypeList(data, query);
      })
    })
    return IndexSystemList
  },
  $_getActPrintTypeList(data, query) {
    let selectType = store.state.model[`${query.selectType}`].filter((type) =>
      query.act_type.split(",").includes(`${type.id}`)
    );
    let typeList = [];
    selectType.forEach((type) => {
      const list = data.filter((item) => item[`${query.modelName}_type`].id === type.id);
      if (list.length === 0) return;
      let typeListData = {
        id: type.id,
        iconImg: type.icon,
        typeColor: "#0585d3",
        title: type.name,
        list: list.map((element) => {
          return {
            id: element.id,
            title: element.last_version.name,
            badge: {
              text: this.$_getActPrintBadge(
                element.last_version.announce_at
              ),
              color: "yellow",
            },
          };
        }),
      };
      typeList.push(typeListData);
    });
    return typeList;
  },
  $_getActPrintBadge(date) {
    if (!date) return;
    const newDate = moment();
    const secondDate = moment(date);
    const month =
      newDate.diff(secondDate, "months", true) <= 3
        ? 3
        : newDate.diff(secondDate, "months", true) <= 6
        ? 6
        : 0;
    if (
      newDate.diff(secondDate, "months", true) <= month &&
      newDate.diff(secondDate, "months", true) >= 0
    ) {
      return i18n.t('近{number}個月異動', {number: month});
    } else {
      return "";
    }
  },
  $_setActFieldData(apiData, indexList, query){
    indexList.third[0].data = apiData
    for (let key in indexList) {
      indexList[key].forEach((field)=>{
        if (field.value === "systemClasses") {
          field.data = this.$_getSelectedSystemClasses(query)
        }
        if (field.value === "current_time") {
          field.data = moment().format("YYYY-MM-DD HH:mm:ss")
        }
        if (field.value === "actTypes"){
          field.data = this.$_getSelectedActTypes(query)
        }
        if (field.value === "current_factory") {
          field.data = `${i18n.t(`${store.state.app.factory.name}`)}`
        }
      })
    }
    return indexList
  },
  $_getSelectedSystemClasses(query){
    let selectedSystemClasses =''
    const querySubClasses = query.system_subclasses.split(",")
    const allSystemClass = [...store.state.model.systemClasses];
    allSystemClass.forEach(element => {
      selectedSystemClasses += `${element.name} | `
      element.system_subclasses.forEach((item)=>{
        if (querySubClasses.includes(`${item.id}`)) {
          selectedSystemClasses += `${item.name} 、`
        }
      })
      selectedSystemClasses = selectedSystemClasses.slice(0, -1)
      selectedSystemClasses += `\n`
    });
    return selectedSystemClasses
  },
  $_getSelectedActTypes(query){
    let selectedActTypes = ''
    const queryActTypes = query.act_type.split(",")
    const allActType = [...store.state.model.actTypes];
    allActType.forEach((element)=>{
      if (queryActTypes.includes(`${element.id}`)){
        selectedActTypes += `${element.name} 、`
      }
    })
    selectedActTypes = selectedActTypes.slice(0, -1)
    return selectedActTypes
  },

}
